// extracted by mini-css-extract-plugin
module.exports = {"container":"share-module--container--3yrSl","icon":"share-module--icon--2jxz_"};